import React from "react";
import moment from "moment";
import { addDefaultSrc } from "../../../utilities";

const Message = ({
  isVyrillMessage,
  isOwnMessage,
  timetoken,
  image,
  children,
  first_name,
  last_name,
}) => (
  <div className="message-container">
    {isVyrillMessage && (
      <div className="vyrill-message">
        <img
          src={require("@src/assets/images/logo/vyrill_new_logo.png").default}
        />
      </div>
    )}
    {!isVyrillMessage && !isOwnMessage && (
      <img src={image} onError={(event) => addDefaultSrc(event)} />
    )}
    <div className="message">
      <div className="message-card">{children}</div>
      <div className="message-footer">
        <small>
          <i className="icon-time" />
          {moment(timetoken / 1e4).fromNow()}
        </small>
      </div>
    </div>
    {isOwnMessage && (
      // <img src={image} onError={(event) => addDefaultSrc(event)} />
      <div className="text-uppercase default-profile-image">
        {first_name && last_name && first_name.charAt(0) + last_name.charAt(0)}
      </div>
    )}
  </div>
);

export default Message;
